import { PROFILE_LOCAL_STORAGE_KEY } from 'modules/profile/constants/index.js'
import getItemLocalStorageUtil from 'modules/local-storage/get-item/index.js'

export default function getEmailFromLocalStorageProfileUtil () {
  return getItemLocalStorageUtil(PROFILE_LOCAL_STORAGE_KEY.EMAIL)
}
